/**
 * CSV export utilities — extracted from AdminDashboard so dashboards stay UI-focused.
 *
 *   const csv = toCSV(rows, [{ label: "Email", value: (r) => r.email }, ...]);
 *   downloadCSV(`waitlist_${todayStamp()}.csv`, csv);
 */

export function csvEscape(value) {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function toCSV(rows, columns) {
  const header = columns.map((c) => csvEscape(c.label)).join(",");
  const body = rows
    .map((row) => columns.map((c) => csvEscape(c.value(row))).join(","))
    .join("\n");
  return header + "\n" + body + "\n";
}

export function downloadCSV(filename, csv) {
  // BOM so Excel opens UTF-8 cleanly
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    try { document.body.removeChild(a); } catch { /* noop */ }
    URL.revokeObjectURL(url);
  }, 1500);
}

export function todayStamp() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;
}
